import { createFileRoute } from "@tanstack/react-router";
import { TimelineTool } from "@/features/marketing/tools/timeline-tool";
import { SEO } from "@/features/marketing/seo";

export const Route = createFileRoute("/_marketing/$lang/wedding-day-timeline")({
  head: SEO.dayTimeline,
  component: TimelineTool,
});
